import { useState, useEffect } from 'react';

function usePagination(itemsPerPage = 10, count: number) {
  const [page, setPage] = useState(1);
  const [contentPerPage, setContentPerPage] = useState(itemsPerPage);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [total, setTotal] = useState(count);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);

  useEffect(() => {
    setNumberOfPages(Math.ceil(total / itemsPerPage));
    setContentPerPage(itemsPerPage);
  }, [itemsPerPage, total]);

  useEffect(() => {
    setNumberOfPages(Math.ceil(total / contentPerPage));
    setPage(1);
  }, [contentPerPage]);

  useEffect(() => {
    const end = page * contentPerPage;
    const start = end - contentPerPage;
    setStartIndex(start);
    setEndIndex(end);
  }, [page, contentPerPage]);

  const changePage = (dir: number) => {
    setPage((prev) => {
      const nextPageCount = prev + dir;
      const confirmedPage =
        nextPageCount < 1
          ? 1
          : nextPageCount > numberOfPages
          ? numberOfPages
          : nextPageCount;
      return confirmedPage;
    });
  };

  return {
    pages: numberOfPages,
    page,
    setPage,
    nextPage: () => changePage(1),
    prevPage: () => changePage(-1),
    perPage: contentPerPage,
    setPerPage: setContentPerPage,
    setTotal,
    startIndex,
    endIndex,
  };
}

export default usePagination;
